module.exports = __webpack_public_path__ + "static/media/error_network_img.b8cdf0ed.svg";